function Command(execute) {
  this.execute = execute;
}

const interfaceCommandsController = {
  api: '',
  paths: '',
  store: '',
};

export function CommandsController({ api, paths } = interfaceCommandsController) {
  const _api = api;
  const _paths = paths;

  function markAsReadNotification(notificationId) {
    const path = _paths.MARK_NOTIFICATION_AS_READ(notificationId);
    return new Command(async () => {
      await _api.Post(path, { unread: false });
    });
  }

  function markAllNotificationAsRead(childId) {
    const path = _paths.MARK_ALL_NOTIFICATIONS_AS_READ(childId);
    return new Command(async () => {
      await _api.Post(path);
    });
  }

  function acceptOrRejectItem({ id, isAccept, child }) {
    const path = _paths.ACCEPT_OR_REJECT_ITEM(id);
    return new Command(async () => await _api.Post(path, { value: isAccept }));
  }

  return {
    markAsReadNotification,
    markAllNotificationAsRead,
    acceptOrRejectItem,
  };
}
